import { useState } from "react";
import { Cliente, Usuario } from "../../types";

interface ClienteFormProps {
  cliente?: Cliente | null;
  usuarios: Usuario[];
  onSubmit: (data: Omit<Cliente, "id" | "fechaCreacion" | "fechaActualizacion">) => void;
  onCancel: () => void;
}

export function ClienteForm({ cliente, usuarios, onSubmit, onCancel }: ClienteFormProps) {
  const [rutValue, setRutValue] = useState(cliente?.rut || "");
  const [nombre, setNombre] = useState(cliente?.nombre || "");
  const [ejecutivoId, setEjecutivoId] = useState(cliente?.ejecutivoId || 0);

  const ejecutivos = usuarios.filter((u) => u.rol === "ejecutivo" || u.rol === "admin");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      rut: rutValue.trim(),
      nombre: nombre.trim(),
      tipoCliente: "holding",
      estado: "activo",
      ejecutivoId,
      holdingId: cliente?.holdingId,
    });
  };

  const isValid = rutValue.trim().length > 0 && nombre.trim().length > 0 && ejecutivoId > 0;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          RUT *
        </label>
        <input
          type="text"
          value={rutValue}
          onChange={(e) => setRutValue(e.target.value)}
          placeholder="76.123.456-7"
          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Nombre *
        </label>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Nombre o razon social"
          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Ejecutivo al Mando *
        </label>
        <select
          value={ejecutivoId}
          onChange={(e) => setEjecutivoId(Number(e.target.value))}
          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value={0}>Seleccionar...</option>
          {ejecutivos.map((u) => (
            <option key={u.id} value={u.id}>
              {u.nombre}
            </option>
          ))}
        </select>
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={!isValid}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors disabled:bg-slate-300 disabled:cursor-not-allowed"
        >
          Guardar
        </button>
      </div>
    </form>
  );
}
